(function () {
  function normalizeName(name) {
    return String(name || '').trim().toLowerCase();
  }

  function optionKind(name) {
    var n = normalizeName(name).split(':')[0].trim();
    if (n === 'set' || n === 'sets' || n === 'pieces' || n === 'piece' || n === 'package' || n === 'configuration' || n.indexOf('set option') !== -1) return 'set';
    if (n === 'size' || n.indexOf('bed size') !== -1 || n.indexOf('mattress size') !== -1) return 'size';
    if (n === 'color' || n === 'colour' || n.indexOf('finish') !== -1) return 'color';
    return '';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function selectedValue(group) {
    var checked = group.querySelector('input:checked');
    if (checked) return checked.value || '';
    var select = group.querySelector('select');
    if (select) return select.value || '';
    return '';
  }

  function findGroups(scope) {
    var groups = [];
    scope.querySelectorAll('[data-fo-product-option], fieldset.options-selection__radios, fieldset.options-selection__swatches, .options-selection__select-wrapper').forEach(function (group) {
      var raw = group.getAttribute('data-fo-product-option') || '';
      if (!raw) {
        var label = group.querySelector('[data-variant-option-name], .options-selection__option-name, .options-selection__select-label, legend, label');
        raw = label ? (label.getAttribute('data-variant-option-name') || label.textContent || '') : '';
      }
      var kind = optionKind(raw);
      if (kind) groups.push({ group: group, kind: kind });
    });
    return groups;
  }

  function lockGroup(group, kind, value) {
    if (!group || group.dataset.foVariantLocked === '1') return;
    group.dataset.foVariantLocked = '1';

    var labels = { set: 'Set configuration', size: 'Size', color: 'Color' };
    var shown = value || selectedValue(group);
    var summary = document.createElement('div');
    summary.className = 'fo-set-lock-summary fo-variant-lock-summary fo-variant-lock-summary--' + kind;
    summary.setAttribute('data-fo-variant-lock-summary', kind);
    summary.innerHTML = '<strong>' + labels[kind] + ':</strong> ' + escapeHtml(shown);

    group.parentNode.insertBefore(summary, group);
    group.style.display = 'none';
  }

  function applyVariantLock(root) {
    var params = new URLSearchParams(window.location.search);
    var legacySetLock = params.get('fo_set_lock') === '1';
    var variantLock = params.get('fo_variant_lock') === '1';
    if (!legacySetLock && !variantLock) return;

    var values = {
      set: params.get('fo_set_value') || '',
      size: params.get('fo_size_value') || '',
      color: params.get('fo_color_value') || ''
    };

    findGroups(root || document).forEach(function (item) {
      if (legacySetLock && !variantLock && item.kind !== 'set') return;
      if (variantLock && values[item.kind] === '') return;
      lockGroup(item.group, item.kind, values[item.kind]);
    });
  }

  function run() { applyVariantLock(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', function (event) {
    applyVariantLock(event.target || document);
  });

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    applyVariantLock(document);
    if (attempts >= 16) clearInterval(timer);
  }, 250);
})();
